<template>
	<div style="margin: 10px;">
		<el-row>
			<el-col :span="24">
				<el-card class="box-card">
					<el-row>
						<el-col :span="24">
							<el-table v-loading="loading" element-loading-text="拼命加载中"
								element-loading-spinner="el-icon-loading"
								element-loading-background="rgba(0, 0, 0, 0.8)" size="mini" ref="multipleTable"
								:data="tableData" style="width: 100%" border
								:header-cell-style="{background:'#E5E7EE',color:'#000000'}" row-key="id">
								<el-table-column type="selection" width="55" align="center">
								</el-table-column>
								<!-- <el-table-column prop="id" label="编号" align="center" width="55">
								</el-table-column>
								<el-table-column prop="columns" label="栏目" align="center">
								</el-table-column>
								<el-table-column prop="title" label="Banner标题" align="left">
								</el-table-column>
								<el-table-column prop="subtitle" label="Banner副标题" align="left">
								</el-table-column>
								<el-table-column prop="description" label="简介" align="left">
								</el-table-column>
								<el-table-column prop="website" label="链接" align="center">
								</el-table-column> -->
								<el-table-column align="center" :prop="dropCol[index].prop" :label="item.label"
									v-for="(item,index) in col" :key="`col_${index}`">
								</el-table-column>
								<el-table-column prop="imagesThumb" label="图片" align="center">
									<template slot-scope="scope">
										<div class="demo-image__preview" @click="preview(scope.row)">
											<img style="width: 80px; height: 80px"
												:src="settings.apiBaseImg+scope.row.images">

										</div>
									</template>
								</el-table-column>

								<el-table-column fixed="right" label="更多操作">
									<template slot-scope="scope">
										<!-- <el-button @click.native.prevent="update('update',scope.$index, scope.row)" type="text" size="small">
											编辑
										</el-button>
										<span>|</span>
										<el-button @click.native.prevent="deleteRow(scope.$index, scope.row)" type="text" size="small">
											删除
										</el-button> -->
										<el-button type="success" icon="el-icon-edit" circle size="small"
											@click.native.prevent="update('update',scope.row)"></el-button>
										<el-button type="danger" icon="el-icon-delete" circle
											@click.native.prevent="deleteRow(scope.$index,scope.row)" size="small">
										</el-button>

									</template>
								</el-table-column>
							</el-table>
							<div class="tableFooter">
								<button class="selectAll" @click="toggleSelection(tableData)"
									style="float: left;">全选</button>
								<button class="del" @click="del" style="float: left;margin-left: 10px;">批量删除</button>
								<input class="add" @click="update('add')" type="button" value="添加图片"
									style="float: left;">
							</div>
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
								:current-page="currentPage" :page-sizes="[5, 10, 15, 20]" :page-size="pageSize"
								layout="total, prev, pager, next, jumper" :total="total">
							</el-pagination>
						</el-col>
					</el-row>

				</el-card>
			</el-col>
		</el-row>
		<fox-preview-image v-model="visiable" :src="srcList" z-index="9000"></fox-preview-image>
	</div>
</template>

<script>
	import request from '../../../assets/js/request.js'
	import qs from 'qs'
	export default {
		data() {
			return {
				form: {
					one: '',
					two: '',
					three: ''
				},
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				loading: false,
				srcList: '',
				visiable: false,
				col: [{
						label: '编号',
						prop: 'id'
					},
					{
						label: '栏目',
						prop: 'columns'
					},
					{
						label: 'Banner标题',
						prop: 'title'
					},
					{
						label: 'Banner副标题',
						prop: 'subTitle'
					}, {
						label: '简介',
						prop: 'description'

					},
					{
						label: '链接',
						prop: 'website'
					},
				],
				dropCol: [{
						label: '编号',
						prop: 'id'
					},
					{
						label: '栏目',
						prop: 'columns'
					},
					{
						label: 'Banner标题',
						prop: 'title'
					},
					{
						label: 'Banner副标题',
						prop: 'subTitle'
					}, {
						label: '简介',
						prop: 'description'

					},
					{
						label: '链接',
						prop: 'website'
					},
				],
			}
		},
		created() {
			this.getData(this.currentPage, this.pageSize)
		},
		mounted() {
			this.rowDrop()
		},
		methods: {
			// 行拖拽
			rowDrop() {
				const tbody = document.querySelector('.el-table__body-wrapper tbody')
				const _this = this
				this.Sortable.create(tbody, {
					onEnd({
						newIndex,
						oldIndex
					}) {
						const currRow = _this.tableData.splice(oldIndex, 1)[0]
						_this.tableData.splice(newIndex, 0, currRow)
					}
				})
			},
			preview(rows) {
				this.visiable = true
				this.srcList = ''
				this.srcList = this.settings.apiBaseImg + rows.images
			},
			//获取列表数据
			getData(currentPage, pageSize) {
				this.loading = true
				var obj = this;
				obj.$http({
					method: 'get',
					url: 'api/v1/banner/page',
					params: {
						pageNum: currentPage,
						pageSize: pageSize,
						uid: localStorage.getItem('uid')
					},
				}).then((res) => {
					if (res.status == 200) {
						this.loading = false
						this.tableData = res.data.data.data
						this.total = res.data.data.total
					} else {
						obj.$message.error(res.data.msg)
					}
				})
			},
			//修改/添加
			update(iden, rows) {
				this.$router.push({
					path: '/home/systemAdd',
					query: {
						rows: rows,
						iden: iden
					}
				})
			},
			deleteRow(index, rows) {
				this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					var obj = this;
					obj.$http({
						method: 'get',
						url: 'api/v1/banner/delete',
						params: {
							id: rows.id,
						},
					}).then((res) => {
						if (res.status == 200) {
							obj.$message.success('删除成功')
							this.getData(this.currentPage, this.pageSize)
						} else {
							obj.$message.error(res.data.msg)
						}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			},
			//分页事件
			handleSizeChange(val) {
				this.pageSize = val; //将每页显示的条数 = 改变的值
				this.getData(this.currentPage, this.pageSize)
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getData(this.currentPage, this.pageSize)
			},
			//全选
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			//批量删除
			del() {
				if (this.$refs.multipleTable.selection.length == 0) {
					this.$message.error('请选择要删除的表格信息！');
					return;
				}
				var list = []
				for (var i = 0; i < this.$refs.multipleTable.selection.length; i++) {
					list.push(this.$refs.multipleTable.selection[i].id)
				}
				this.$confirm('此操作将永久删除所选信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					var obj = this;
					obj.$http({
						method: 'get',
						url: 'api/v1/banner/clear',
						params: {
							ids: list.toString(),
							uid: localStorage.getItem('uid')
						},
					}).then((res) => {
						if (res.status == 200) {
							obj.$message.success('删除成功')
							this.getData(this.currentPage, this.pageSize)
						} else {
							obj.$message.error(res.data.msg)
						}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}
		},
	}
</script>

<style scoped="scoped">
	/deep/ .el-input__inner {
		height: 40px !important;
	}

	/deep/ .el-form-item__label {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #000000;
		line-height: 24px;
	}

	/deep/ .el-button--text {
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #7C96F8;
		line-height: 24px;
	}

	span {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #7C96F8;
		line-height: 24px;
	}

	.chenggong {
		width: 49px;
		height: 16px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 24px;
		opacity: 0.7;
	}

	.fail {
		width: 33px;
		height: 16px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #76B67E;
		line-height: 24px;
	}

	/deep/ .el-message {
		z-index: 9999999999999;
	}
</style>



// WEBPACK FOOTER //
// src/views/system/systemBanner/systemBanner.vue